import { render, staticRenderFns } from "./Appreciation.vue?vue&type=template&id=3a969d9a&"
import script from "./Appreciation.vue?vue&type=script&lang=ts&"
export * from "./Appreciation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Appreciation.vue"
export default component.exports